import { Add, Delete, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, Typography } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
    IMaterial,
    IMaterialInputFormSection,
    IMaterialNote
} from '../../interfaces';



export const NotesFormSection: React.SFC<IMaterialInputFormSection> = ({
    material,
    onUpdate,
    ...props
}: IMaterialInputFormSection) => {
    const [notes, setNotes] = useState<IMaterialNote[]>(material.notes ? [...material.notes] : []);

    const onUpdateNotes = (index: number, value: string) => {
        const updatedNotes = [...notes];
        updatedNotes[index].note = value;
        setNotes(updatedNotes);
        onUpdate('notes', updatedNotes);
    };

    const addNote = () => {
        const updatedNotes = [...notes, { note: '' } as IMaterialNote];
        setNotes(updatedNotes);
        onUpdate('notes', updatedNotes);
    };

    const deleteNote = (index: number) => {
        const updatedNotes = [...notes];
        updatedNotes.splice(index, 1);
        setNotes(updatedNotes);
        onUpdate('notes', updatedNotes);
    };

    useEffect(() => {
        setNotes(material.notes ? [...material.notes] : []);
    }, [material]);

    return (
        <Accordion defaultExpanded={true}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h6" color="primary">
                    Notes
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    {notes.map((note: IMaterialNote, index: number) => (
                        <>
                            <Grid item xs={10} key={index}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={note.note}
                                    onChange={(e) => onUpdateNotes(index, e.currentTarget.value)}
                                    placeholder="Any additional notes about this material"
                                />

                            </Grid>
                            <Grid item xs={2}>
                                <IconButton onClick={() => deleteNote(index)}>
                                    <Delete />
                                </IconButton>
                            </Grid>
                        </>

                    ))}
                    <Grid item xs={12}>
                        <IconButton onClick={addNote}>
                            <Add />
                        </IconButton>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};


//export const NotesFormSection: React.SFC<IMaterialInputFormSection> = ({
//    material,
//    onUpdate,
//    ...props
//}: IMaterialInputFormSection) => {


//    const onUpdateNotes = (opt: string | null) => {
//        if (opt !== null) {
//            let m: IMaterial = cloneDeep(material);

//            if (!m.notes || !m.notes[0]) m.notes = [{ note: opt, materialId: material.materialId }];
//            else m.notes[0].note = opt;
//            onUpdate("notes", m.notes);
//        }
//    }

//    const getNote = () => {
//        return material.notes ? material.notes[0]?.note : "";
//    }

//    useEffect(() => {

//    }, [material])

//    return (
//        <Accordion
//            defaultExpanded={true}
//        >
//            <AccordionSummary
//                expandIcon={<ExpandMore />}
//            >
//                <DialogContentText color="primary">
//                    Notes
//                </DialogContentText>
//            </AccordionSummary>
//            <AccordionDetails>

//                <Grid container>
//                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
//                        <TextField
//                            fullWidth
//                            variant="outlined"
//                            multiline
//                            rows={3}
//                            label="Notes"
//                            value={getNote()}
//                            onChange={(e) => onUpdateNotes(e.currentTarget.value)}
//                            helperText="Any additional notes about this material"
//                        />
//                    </Grid>

//                </Grid>

//            </AccordionDetails>
//        </Accordion>

//    );
//}